<template>

  <b-container fluid style="padding-top: 5px">
    <div v-if="displayMetricsOwnerIfAdmin" style="text-align: center">
      Current Winery: {{ this.wineryName }}
    </div>
    <div style="text-align: center">
      <b-row>
        <b-col cols="3">

        </b-col>
        <b-col cols="6">
          <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Metric Year:" label-for="input-sm">
            <b-form-select :options="availableYearList" @change="updateYear" v-model="selectedMetricYear">
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="3">

        </b-col>
      </b-row>
    </div>
    <b-row align-h="start">
      <b-col cols="12"><p style="color: #1c7430; font-style: italic; margin-left: 20px">Please use the
        annual tabs to generate the resource totals (this is a general template - provide
        the data sources specific to your winery). The monthly data entered on the annual tabs will
        automatically populate the Metrics Summary page and generate trend graphs on the Resource
        Graphs page. For newly certifying wineries please provide resource and production data for the
        past 2-3 years. For re-certifying wineries please provide data since your last resource
        audit. <span @click="privacyPolicy"><i class="fas fa-user-lock fa-2x"></i></span></p>
        <p style="color: #1c7430; font-style: italic; margin-left: 20px">Please enter data in whole
          numbers only.</p></b-col>
    </b-row>
    <b-row v-if="shouldAllowOperationCreation">
      <b-col md="2"></b-col>
      <b-col md="2"> Select Vineyard:</b-col>
      <b-col md="6">
        <b-form-select
            v-model="currentMetricsGroupId"
            :options="organizationList"
            value-field="_id"
            text-field="name"
            @change="updateMetricsGroup">

        </b-form-select>
      </b-col>
      <b-col md="2">
        <b-button @click="createOperation">Add Vineyard</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="2">
      </b-col>
      <b-col cols="8" style="text-align: center">
        <router-link
            class="section-button"
            tag="button" :to="`#water-${selectedMetricYear}`" @click.native="scrollTo(`#water-${selectedMetricYear}`)">
          Water
        </router-link>
        <router-link
            class="section-button"
            tag="button" :to="`#electric-${selectedMetricYear}`"
            @click.native="scrollTo(`#electric-${selectedMetricYear}`)">
          Electricity
        </router-link>
        <router-link
            class="section-button"
            tag="button" :to="`#gas-${selectedMetricYear}`" @click.native="scrollTo(`#gas-${selectedMetricYear}`)">Gas
        </router-link>
        <router-link
            class="section-button"
            tag="button" :to="`#production-${selectedMetricYear}`"
            @click.native="scrollTo(`#production-${selectedMetricYear}`)">Production
        </router-link>
      </b-col>
      <b-col cols="2">
      </b-col>
    </b-row>
    <template slot="title">
      {{ "item" }}
    </template>
    <b-container v-if="displayWineryMenu">
      <WaterMetric :rows="waterYear.months" :year="selectedMetricYear"
                   :id="waterYear._id" :groupId="currentMetricsGroupId" :key="selectedMetricYear"
                   v-if="loaded">
      </WaterMetric>
      <MetricTable :rows="electricYear.months" :year="selectedMetricYear"
                   :id="electricYear._id" :groupId="currentMetricsGroupId" :key="selectedMetricYear"
                   v-if="loaded">
      </MetricTable>
      <GasMetricTable :rows="gasYear.months" :year="selectedMetricYear" :groupId="currentMetricsGroupId"
                      :id="gasYear._id" :key="selectedMetricYear"
                      v-if="loaded">
      </GasMetricTable>
    </b-container>
    <b-container fluid="sm" v-else>
      <VineyardWaterMetricTable :rows="waterYear.months" :year="selectedMetricYear"
                                :id="waterYear._id" :groupId="currentMetricsGroupId" :key="selectedMetricYear"
                                v-if="loaded">
      </VineyardWaterMetricTable>
      <VineyardPowerMetricTable :rows="electricYear.months" :year="selectedMetricYear"
                                :id="electricYear._id" :groupId="currentMetricsGroupId"
                                :key="selectedMetricYear" v-if="loaded">
      </VineyardPowerMetricTable>
      <VineyardGasMetricTable :rows="gasYear.months" :year="selectedMetricYear" :groupId="currentMetricsGroupId"
                              :id="gasYear._id" :key="selectedMetricYear" v-if="loaded">
      </VineyardGasMetricTable>
      <VineyardFertilizerMetricTable :rows="fertilizerYear.months" :year="selectedMetricYear"
                                     :id="fertilizerYear._id" :groupId="currentMetricsGroupId"
                                     :key="selectedMetricYear" v-if="loaded">
      </VineyardFertilizerMetricTable>
    </b-container>
    <b-row :id="`production-${selectedMetricYear}`">
      <b-col sm="1">
      </b-col>
      <b-col sm="5">
        <WineProduction :year="Number(selectedMetricYear)" v-if="displayWineryMenu"
                        :key="selectedMetricYear"></WineProduction>
        <VineyardProduction :year="Number(selectedMetricYear)" :group-id="currentMetricsGroupId"
                            :key="selectedMetricYear" v-else></VineyardProduction>
        <NitrogenProduction :year="Number(selectedMetricYear)" data="nitrogenProduction"
                            :group-id="currentMetricsGroupId"
                            v-if="!displayWineryMenu" :key="selectedMetricYear"></NitrogenProduction>
        <WasteDiversion :year="Number(selectedMetricYear)" v-if="displayWineryMenu"
                        :group-id="currentMetricsGroupId" :key="selectedMetricYear"></WasteDiversion>
      </b-col>

      <b-col sm="5">
        <PerCaseMetrics :year="Number(selectedMetricYear)" v-if="displayWineryMenu"
                        :key="selectedMetricYear"></PerCaseMetrics>
        <PerTonMetrics :year="Number(selectedMetricYear)" v-else :key="selectedMetricYear"></PerTonMetrics>
        <Co2Metrics :year="Number(selectedMetricYear)" v-if="!displayWineryMenu" :group-id="currentMetricsGroupId"
                    :key="selectedMetricYear"></Co2Metrics>
        <WineryCo2Metrics :year="Number(selectedMetricYear)" v-if="displayWineryMenu"
                          :group-id="currentMetricsGroupId" :key="selectedMetricYear"></WineryCo2Metrics>
      </b-col>
      <b-col sm="1">
      </b-col>
    </b-row>
    <b-row style="height: 20px"></b-row>
    <b-row>
      <b-col sm="3"></b-col>
      <b-col sm="3" align-h="center" v-if="displayWineryMenu">
        <router-link :to="{name:'Metrics Summary', params:{groupId: currentMetricsGroupId}}" tag="button"
                     style="color:  white; background-color: green; height: 40px; width: 65%">
          Metric Summary
        </router-link>
      </b-col>
      <b-col sm="3" align-h="center" v-if="displayWineryMenu">
        <router-link :to="{name:'Resource Graphs', params:{groupId: currentMetricsGroupId}}" tag="button"
                     style="color: white; background-color: green; height: 40px; width: 65%">
          Resource Graphs
        </router-link>
      </b-col>
      <b-col sm="3" align-h="center" v-else>
        <router-link :to="{name:'Vineyard Resource Graphs', params:{groupId: currentMetricsGroupId}}" tag="button"
                     style="color: white; background-color: green; height: 40px; width: 65%">
          Resource Graphs
        </router-link>
      </b-col>
      <b-col sm="3"></b-col>
    </b-row>
    <b-row style="height: 20px"></b-row>
    <div style="padding-top: 5px; padding-bottom: 10px;" v-if="displayWineryMenu">
      <b-row align-h="start" style="background-color: lightgray">
        <b-col cols="4">
          <div
              style="margin-left: 20px; margin-top: 5px; font-weight:bold; font-size:large; vertical-align: center ">
            Resource Data Totals
          </div>
        </b-col>
        <b-col cols="2">
          <div style="vertical-align: center; padding: 5px;">
            <b-btn v-b-toggle.collapse-1 class="bg-transparent chev-btn">
                                    <span class="when-opened">
                                    <i class="fa fa-chevron-down" aria-hidden="true" style="color: #1b1e21;"></i>
                                    </span>
              <span class="when-closed">
                                    <i class="fa fa-chevron-up" aria-hidden="true" style="color: #1b1e21;"></i>
                                    </span>
            </b-btn>
          </div>
        </b-col>
      </b-row>

      <b-collapse id="collapse-1" class="mt-2">
        <MetricsSummaryBlock :year="selectedMetricYear" :key="selectedMetricYear"></MetricsSummaryBlock>
      </b-collapse>
    </div>
    <MetricComment :year="selectedMetricYear" :groupId="currentMetricsGroupId"
                   :metric-type="displayWineryMenu? 'WINE' : 'VINEYARD' ">
    </MetricComment>
    <Modal v-model="showFirstModal" title="Create Vineyard"
           :modal-style="{ 'max-width': '1000px' }">
      <form novalidate>
        <b-container fluid="true" style="margin:20px; max-width: 1000px;"
                     id="modalQuestionId">
          <CreateOperation ref="operationCreator"></CreateOperation>
        </b-container>
        <div class="row modal-footer">
          <div class="col-sm-12">
            <div class="float-right">
              <button class="btn btn-primary" type="button" @click="closeModal">Ok</button>
              <b-button class="btn btn-secondary ml-2" type="button" @click="closeModal">Cancel</b-button>
            </div>
          </div>
        </div>
      </form>

    </Modal>
  </b-container>
</template>
<script>
import MetricTable from "./MetricTable";
import WaterMetric from "./WaterMetric";
import GasMetricTable from "./GasMetric";
import MetricsSummaryBlock from "./MetricsSummaryBlock";
import WineProduction from "./WineProduction";
import PerCaseMetrics from "./PerCaseMetrics";
import PerTonMetrics from "@/components/vineyard/metrics/production/PerTonMetrics";
import Bus from "../eventBus";
import Swal from "sweetalert2";
import VineyardWaterMetricTable from "@/components/vineyard/metrics/VineyardWaterMetric";
import VineyardPowerMetricTable from "@/components/vineyard/metrics/VineyardPowerMetricTable";
import VineyardGasMetricTable from "@/components/vineyard/metrics/VineyardGasMetricTable";
import VineyardFertilizerMetricTable from "@/components/vineyard/metrics/VineyardFertilizerMetricTable";
import VineyardProduction from "@/components/vineyard/metrics/production/VineyardProduction";
import NitrogenProduction from "@/components/vineyard/metrics/production/NitrogenProduction";
import Co2Metrics from "@/components/vineyard/metrics/production/Co2Metrics";
import VueModal from "@kouts/vue-modal";
import CreateOperation from "@/components/vineyard/CreateOperation";
import MetricComment from "@/components/metrics/MetricComment";
import WasteDiversion from "@/components/vineyard/metrics/WasteDiversion";
import WineryCo2Metrics from "@/components/winery/metrics/WineryCo2Metrics";

const TIMEOUT = 1;

export default {
  name: 'MetricsCalculatorSingle',
  components: {
    WasteDiversion,
    NitrogenProduction,
    VineyardProduction,
    PerTonMetrics,
    VineyardFertilizerMetricTable,
    VineyardGasMetricTable,
    VineyardPowerMetricTable,
    VineyardWaterMetricTable,
    PerCaseMetrics,
    WineProduction,
    MetricsSummaryBlock,
    MetricTable,
    WaterMetric,
    GasMetricTable,
    Co2Metrics,
    'Modal': VueModal,
    CreateOperation,
    MetricComment,
    WineryCo2Metrics
  },
  props: {groupId: String},
  data() {
    return {
      //selectedMetricYear: 2023,
      //availableYearsOfMetrics: ['2017','2018','2019','2020','2021','2022','2023'],
      gridApi: null,
      gridColumnApi: null,
      rowData: [],
      winerySections: {},
      vineyardSections: {},
      currentMetricsGroupId: this.groupId || localStorage.getItem('adminImpersonationGroupId') || localStorage.getItem('currentMetricsGroupId') || localStorage.getItem('groupId'),
      currentMetricsGroupId_old: this.groupId || localStorage.getItem('currentMetricsGroupId'),
      currentEntityType: localStorage.getItem("adminImpersonationEntityType") || localStorage.getItem("entityType"),
      isAdmin: localStorage.getItem('roles') !== null && localStorage.getItem('roles').includes('admin'),
      wineryName: '',
      organizationList: [{text: "First Operation", value: '123edaf34de'}, {
        text: "Second Operation",
        value: '123edaf34df'
      }],
      showFirstModal: false,
      waterYear: {_id: 'none', months: []},
      electricYear: {_id: 'none', months: []},
      gasYear: {_id: 'none', months: []},
      fertilizerYear: {_id: 'none', months: []},
      currentAdminGroupId: this.groupId,
      loaded: false
    }
  },
  computed: {
    selectedMetricYear: {
      get() {
        return this.$store.getters['selectedMetricYear']
      },
      set(payload) {
        console.log("SelectedMetricsYear: ", payload);
        return this.$store.commit('selectedMetricYear', payload);
      }
    },
    displayWineryMenu: function () {
      console.log("Check entityType!");
      let entityNode = this.currentEntityType;
      return entityNode === "WINE";
    },
    displayMetricsOwnerIfAdmin: function () {
      return this.isAdmin;
    },
    shouldAllowOperationCreation: function () {
      return this.organizationList
          .filter(org => org.entityType === "VINEYARD").length > 0 && !this.isAdmin
    },
    availableYearList: function () {
      let year = 2017;
      let yearList = [];
      while (year <= new Date().getFullYear()) {
        yearList.push(year.toString())
        ++year;
      }
      return yearList
    }
  },
  created() {
    Bus.$on('operation-creation', this.handleOperationCreation);
  },
  beforeDestroy() {
    Bus.$off('operation-creation', this.handleOperationCreation);
  },
  mounted() {
    this.getGroupInfo();
    if (this.$route.hash) {
      setTimeout(() => this.scrollTo(this.$route.hash), TIMEOUT)
    }
  },
  beforeMount() {
    this.loadGroups();
    this.getMetricData();
  },

  methods: {
    handleOperationCreation: function (operation) {
      if ("reload-groups" === operation) {
        this.loadGroups();
      }
    },
    updateYear: function (newValue) {
      console.log(`Zippy New metrics year: ${this.selectedMetricYear}`)
      let self = this;
      self.selectedMetricYear = newValue;
      this.$store.commit("selectedMetricYear", newValue);
      console.log(`At Next Tick Selected metrics year: ${this.selectedMetricYear}`)
      console.log(`At Next Tick New metrics year: ${newValue}`);
      this.getMetricData();
      this.loaded = true;
    },
    loadGroups: function () {
      this.$http.get("account/user/" + localStorage.getItem("user") + "/groups")
          .then(result => {
            this.organizationList = result.data;
            console.log(this.requests)
          })
          .catch(error => {
            console.log("Couldn't Retrieve Requests", error.message);
          })
    },
    getSectionsByType() {
      if (this.displayWineryMenu) {
        return this.winerySections;
      } else {
        return this.vineyardSections;
      }
    },
    updateMetricsGroup: function () {
      let currentGroup = this.organizationList.find(org => org._id === this.currentMetricsGroupId);
      this.currentEntityType = currentGroup ? currentGroup.entityType : "unknown";
      if (!currentGroup) {
        console.warn(`updateMetricsGroup: no organization found for id "${this.currentMetricsGroupId}"`);
        this.$toasted.error('Unable to change group: selected group was not found.');
        return;
      }
      let self = this;
      this.$store.commit("currentMetricsGroupId", currentGroup._id);
      this.$store.dispatch('loadProductionData');
      this.updateYear(new Date().getFullYear());
      console.log("Getting New Metrics Data")
      this.getMetricData();
    },
    createOperation: function () {
      console.log("Open Modal");
      this.showFirstModal = true;
    },
    populateWineryData: function (wineryData) {
      let self = this;
      let powerYearList = wineryData.power;
      let waterYearList = wineryData.water;
      let gasYearList = wineryData.gas;


      powerYearList.forEach(function (key) {
        key.months.forEach(x => {
          x.year = key.year;
        });
        self.rowData[key.year] = key
      });
      waterYearList.forEach(function (key) {
        key.months.forEach(x => {
          x.year = key.year;
        });
        self.rowData[key.year] = key
      });
      gasYearList.forEach(function (key) {
        key.months.forEach(x => {
          x.year = key.year;
        });
        self.rowData[key.year] = key
      });
      self.winerySections = {
        power: powerYearList,
        water: waterYearList,
        gas: gasYearList
      };
      self.waterYear = waterYearList[0];
      self.electricYear = powerYearList[0];
      self.gasYear = gasYearList[0];
      self.$store.commit("wineryMetrics/calcAndUpdateWineryPowerData", powerYearList[0]);
      self.$store.commit("wineryMetrics/calcAndUpdateWineryGasData", gasYearList[0]);
      self.$store.commit("wineryMetrics/calcAndUpdateWineryWaterData", waterYearList[0]);
    },
    populateVineyardData: function (vineyardData) {
      let self = this;
      let powerYearList = vineyardData.power;
      let waterYearList = vineyardData.water;
      let gasYearList = vineyardData.gas;
      let fertilizerYearList = vineyardData.fertilizer;
      powerYearList.forEach(function (key) {
        key.months.forEach(x => {
          x.year = key.year;
        });
        self.rowData[key.year] = key
      });
      waterYearList.forEach(function (key) {
        key.months.forEach(x => {
          x.year = key.year;
        });
        self.rowData[key.year] = key
      });
      gasYearList.forEach(function (key) {
        key.months.forEach(x => {
          x.year = key.year;
        });
        self.rowData[key.year] = key
      });
      fertilizerYearList.forEach(function (key) {
        key.months.forEach(x => {
          x.year = key.year;
        });
        self.rowData[key.year] = key
      });
      self.vineyardSections = {
        power: powerYearList,
        water: waterYearList,
        gas: gasYearList,
        fertilizer: fertilizerYearList
      };
      self.waterYear = waterYearList[0];
      self.electricYear = powerYearList[0];
      self.gasYear = gasYearList[0];
      self.fertilizerYear = fertilizerYearList[0];
      self.$store.commit("calcAndUpdateVineyardPowerData", powerYearList[0]);
      self.$store.commit("calcAndUpdateVineyardFertilizerData", fertilizerYearList[0]);
      self.$store.commit("calcAndUpdateVineyardGasData", gasYearList[0]);
      self.$store.commit("calcAndUpdateVineyardWaterData", waterYearList[0]);
    },
    getMetricData: function () {
      console.log("Selected Metrics year: {}", this.selectedMetricYear);
      console.log("Current Metrics Group: {}", this.currentMetricsGroupId);

      let metricYear = this.selectedMetricYear || new Date().getFullYear().toString();
      console.log("Metrics year is: ", metricYear);

      if (metricYear == null) {
        console.log("Selected Metrics year is null", this.selectedMetricYear);
        return;
      }

      let self = this;
      let metricsGroup = this.currentMetricsGroupId;
      let metric_url = this.displayWineryMenu ? "metrics/new/all/" + metricsGroup + "/" + metricYear :
          "metrics/vineyard/new/all/" + metricsGroup + "/" + metricYear;
      this.$http.get(metric_url)
          .then(result => {
            if (self.displayWineryMenu) {
              this.populateWineryData(result.data);
            } else {
              this.populateVineyardData(result.data);
            }
            this.loaded = true;
          })
          .catch(error => {
            console.log("Had issue pulling data:" + error.message);
            console.log(error)
          });
    },
    closeModal: function () {
      this.$refs['operationCreator'].submitOperation();
      this.showFirstModal = false;
    },
    scrollTo: function (hashtag) {
      setTimeout(() => {
        location.href = hashtag
      }, TIMEOUT)
    },
    privacyPolicy: function () {
      Swal.fire({
        title: 'Privacy Policy',
        html: 'Napa Green respects the privacy of its members and keeps information confidential.' +
            ' Please refer to the <a href="/static/napa_green_access_confidentiality_agreement.pdf"' +
            ' target="_blank" style="color: darkred">\n' +
            ' Napa Green Access and Confidentiality Agreement</a> for more information',
        icon: 'info'
      });
    },
    getUniqueYears: function (theSections) {
      let set = new Set();
      if (!theSections || !theSections.power) {
        return set;
      }
      theSections.power.forEach(section => {
        set.add(section.year);
      })
      return set;
    },
    getYearThingPower: function (sections, item) {
      return sections.power.filter(pow => {
        return pow.year === item;
      })[0];
    },
    getYearThingPowerId: function (sections, item) {
      let filterElement = sections.power.filter(pow => {
        return pow.year === item;
      })[0];
      return filterElement._id
    },
    getYearThingGas: function (sections, item) {
      return sections.gas.filter(gas => {
        return gas.year === item;
      })[0];
    },
    getYearThingFertilizer: function (sections, item) {
      let fertilizer = sections.fertilizer;

      if (fertilizer) {
        return fertilizer.filter(fert => {
          return fert.year === item;
        })[0];
      } else {
        return {};
      }
    },
    getYearThingGasId: function (sections, item) {
      let filterElement = sections.gas.filter(gas => {
        return gas.year === item;
      })[0];
      return filterElement._id
    },
    getYearThingFertilizerId: function (sections, item) {
      if (this.displayWineryMenu || this.winerySections === null) {
        return null;
      }
      let filterElement = sections.fertilizer.filter(fert => {
        return fert.year === item;
      })[0];
      return filterElement._id
    },
    getYearThingWater: function (sections, item) {
      let waterYear = sections.water.filter(wat => {
        return wat.year === item;
      })[0];
      console.log("Water Year Returned: ", waterYear);
      return waterYear;
    },
    getYearThingWaterId: function (sections, item) {
      let filterElement = sections.water.filter(wat => {
        return wat.year === item;
      })[0];
      return filterElement._id
    },
    tabClick: function () {
    },
    // onCellEditingStopped(event) {
    //   let self = this;
    //   let total = 0;
    //   if (self.gridApi !== undefined) {
    //     self.gridApi.forEachNode(function (node) {
    //       if (node.data["year"] === event.data["year"]) {
    //         total += parseInt(node.data[event.colDef.field], 10);
    //       }
    //     });
    //   }
    //
    //   this.bottomGridOptions.api.getRowNode('0').data[event.colDef.field] = total;
    //   this.bottomGridOptions.api.getRowNode('0')
    //
    //   this.bottomGridOptions.api.redrawRows({rowNodes: [this.bottomGridOptions.api.getRowNode('0')]})
    // },
    getGroupInfo: function () {
      this.$http.get("/groups/name/" + this.currentAdminGroupId, {
        headers: {
          'content-type': 'application/json'
        }
      }).then(response => {
        this.wineryName = response.data.name;
      }).catch(error => {
        console.log("Error getting Data: " + error);
      });
    }
  }
}
</script>
<style>
hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}

.chev-btn {
  background-color: Transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  background-image: none;
  outline: none;
}

.chev-btn:hover {
  background-color: rgba(255, 255, 255, 0);
  cursor: pointer;
  outline: none;

}

.chev-btn:focus, .chev-btn:active {
  outline: none !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

.section-button {
  color: white;
  background-color: green;
  height: 40px;
  margin: 5px;
  width: 100px;
}


.modal-footer {
  padding: 15px 0 0 0;
  border-top: 1px solid #e5e5e5;
  margin-left: -14px;
  margin-right: -14px;
}

.modal-question-number {
  position: absolute;
  top: 0;
  left: 0;
  margin-right: 5px;
  text-align: right;
}

.modal-question-text {
  padding-left: 10px;
  padding-bottom: 10px;
  margin-left: 10px;
  width: 100%;
  font-size: 20px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  display: inline-block;
}
</style>
